<template>
    <Button
        :type="isNotEmpty ? 'primary' : 'default'"
        :ghost="isNotEmpty"
        @click="onClick"
    >
        <span class="adv-text">筛选</span>
        <common-icon
            class="adv-icon"
            type="ios-funnel"
            :size="14"
            :color="isNotEmpty ? $theme.primaryColor : 'black'"
        ></common-icon>
        <smart-modal
            v-model="show"
            :width="800"
            :height="600"
            :maskClosable="false"
            :showHeader="false"
            :modalBeforeEnter="fetch"
            :modalBeforeBtnClick="btnHandlers"
            :buttons="buttons"
            @close-by-confirm="onConfirm"
        >
            <Form
                class="adv-form"
                ref="pInfo"
                :model="pInfo"
                :rules="rules"
                :label-width="200"
                label-position="top"
            >
                <FormItem label="房源编号" prop="search">
                    <Input
                        v-model="pInfo.search"
                        placeholder="请输入房源编号"
                        style="display: inline-block; width: 220px"
                    ></Input>
                    <span style="margin-left: 30px"
                        >房源编号规则：楼栋英文-楼层-房号。如C83,9621,BB523</span
                    >
                </FormItem>
                <FormItem label="租约状态" prop="contractStatus">
                    <check-tag-group
                        v-model="pInfo.contractStatus"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in contractStatusList"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="租赁期限" prop="rentLength">
                    <check-tag-group
                        v-model="pInfo.rentLength"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in enums.RENT_LENGTH.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="租客交费方式" prop="RENT_PAY_METHOD">
                    <check-tag-group
                        v-model="pInfo.rentPayMethod"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in enums.RENT_PAY_METHOD.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="客户类型" prop="cusType">
                    <check-tag-group
                        v-model="pInfo.cusType"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in dict.cusType.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="签约人" prop="createUser">
                    <check-tag-group
                        v-model="pInfo.createUser"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in createUserList"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.nickname }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="时间" prop="remark">
                    <div>
                        <div class="flex">
                            <check-tag-group
                                v-model="includeContractCreateTime"
                                color="primary"
                                multiple
                                @on-change="onContractCreateTimeChange"
                                ><check-tag
                                    class="adv-check-tag"
                                    name="createTime"
                                    >合同操作日期</check-tag
                                >
                            </check-tag-group>
                            <filter-date-range
                                v-show="includeContractCreateTime.length"
                                :startDate.sync="pInfo.contractCreateTime1"
                                :endDate.sync="pInfo.contractCreateTime2"
                            ></filter-date-range>
                        </div>
                        <div class="flex">
                            <check-tag-group
                                v-model="includeContractStartTime"
                                color="primary"
                                multiple
                                @on-change="onContractStartTimeChange"
                                ><check-tag
                                    class="adv-check-tag"
                                    name="startTime"
                                    >合同开始日期</check-tag
                                >
                            </check-tag-group>
                            <filter-date-range
                                v-show="includeContractStartTime.length"
                                :startDate.sync="pInfo.contractStartTime1"
                                :endDate.sync="pInfo.contractStartTime2"
                            ></filter-date-range>
                        </div>
                        <div class="flex">
                            <check-tag-group
                                v-model="includeContractEndTime"
                                color="primary"
                                multiple
                                @on-change="onContractEndTimeChange"
                                ><check-tag class="adv-check-tag" name="endTime"
                                    >合同结束日期</check-tag
                                >
                            </check-tag-group>
                            <filter-date-range
                                v-show="includeContractEndTime.length"
                                :startDate.sync="pInfo.contractEndTime1"
                                :endDate.sync="pInfo.contractEndTime2"
                            ></filter-date-range>
                        </div>
                    </div>
                </FormItem>
            </Form>
        </smart-modal>
    </Button>
</template>

<script>
import FilterDateRange from '_vc/filter/filter-date-range'
import { usersByOrg } from '@/api/sys-org'
import { type } from '_u/helper'

export default {
    name: 'ContractAdvSearch',
    components: {
        FilterDateRange,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            show: false,
            buttons: [
                { type: 'default', text: '重置', name: 'reset' },
                { type: 'primary', text: '确定', name: 'confirm' },
            ],
            btnHandlers: {
                reset: this.onReset,
            },
            dict: {
                contractStatus: this.$dict.NULL,
                cusType: this.$dict.NULL,
            },
            enums: {
                RENT_LENGTH: this.$enum.get('RENT_LENGTH'),
                RENT_PAY_METHOD: this.$enum.get('RENT_PAY_METHOD'),
            },
            pInfo: {
                search: '',
                contractStatus: [],
                rentLength: [],
                rentPayMethod: [],
                cusType: [],
                createUser: [],
                contractCreateTime1: '',
                contractCreateTime2: '',
                contractStartTime1: '',
                contractStartTime2: '',
                contractEndTime1: '',
                contractEndTime2: '',
            },
            createUserList: [],
            includeContractCreateTime: [],
            includeContractStartTime: [],
            includeContractEndTime: [],
        }
    },
    computed: {
        contractStatusList() {
            var list = this.dict.contractStatus.toList(),
                allow = ''

            if (this.name === 'contractRent') {
                allow = ',1,2,3,4,5,6,11,27,28,29,'
                list = list.filter((v) => allow.indexOf(`,${v.id},`) >= 0)
            }
            if (this.name === 'contractHistory') {
                allow = ',7,8,9,21,22,23,24,25,26,'
                list = list.filter((v) => allow.indexOf(`,${v.id},`) >= 0)
            }
            return list
        },
        rules() {},
        isNotEmpty() {
            return Object.values(this.value).some((v) => v.length)
        },
    },
    methods: {
        fetch(next) {
            return Promise.all([
                this.$dict.get(['contract_status', 'cus_type']),
                usersByOrg('楼栋管理员'),
            ])
                .then((args) => {
                    var [group, user] = args

                    Object.assign(this.dict, group)
                    this.createUserList = user.data.data
                    // 重新赋值
                    var val = this.value || {}
                    Object.keys(this.pInfo).forEach((k) => {
                        if (typeof val[k] !== 'undefined') {
                            this.pInfo[k] = val[k]
                        }
                    })
                    this.includeContractCreateTime =
                        this.pInfo.contractCreateTime1 ||
                        this.pInfo.contractCreateTime2
                            ? ['createTime']
                            : []
                    this.includeContractStartTime =
                        this.pInfo.contractStartTime1 ||
                        this.pInfo.contractStartTime2
                            ? ['startTime']
                            : []
                    this.includeContractEndTime =
                        this.pInfo.contractEndTime1 ||
                        this.pInfo.contractEndTime2
                            ? ['endTime']
                            : []
                })
                .then(() => next())
        },
        onClick() {
            this.show = true
        },
        onConfirm() {
            this.$emit('input', this.pInfo)
            this.$emit('confirm', this.pInfo, this.getSelectedOptions())
        },
        onContractCreateTimeChange(val) {
            if (val.length <= 0) {
                this.pInfo.contractCreateTime1 = ''
                this.pInfo.contractCreateTime2 = ''
            }
        },
        onContractStartTimeChange(val) {
            if (val.length <= 0) {
                this.pInfo.contractStartTime1 = ''
                this.pInfo.contractStartTime2 = ''
            }
        },
        onContractEndTimeChange(val) {
            if (val.length <= 0) {
                this.pInfo.contractEndTime1 = ''
                this.pInfo.contractEndTime2 = ''
            }
        },
        // 重置
        onReset(next, options) {
            options.closeModal = false
            Object.keys(this.pInfo).forEach((k) => {
                this.pInfo[k] = typeof this.pInfo[k] === 'object' ? [] : ''
            })
            next()
        },
        getSelectedOptions() {
            var options = []

            Object.keys(this.pInfo).forEach((k) => {
                var v = this.pInfo[k]

                // 日期区间
                // prettier-ignore
                if (k.indexOf('Time1') >= 0) {
                    var t1 = k,
                        t2 = k.replace('Time1', 'Time2'),
                        v1 = this.pInfo[t1],
                        v2 = this.pInfo[t2],
                        title

                    if(!v1 && !v2){
                        return
                    }

                    if (k === 'contractCreateTime1') {
                        title = '合同提交日期'
                    }
                    if (k === 'contractStartTime1') {
                        title = '合同开始日期'
                    }
                    if (k === 'contractEndTime1') {
                        title = '合同结束日期'
                    }

                    options.push({
                        id: `${v1}-${v2}`,
                        key: `${t1}-${t2}`,
                        text: `${v || '不限'}至${this.pInfo[t2] || '不限'}`,
                        label: `${title}`
                    })
                } else if (v) {
                    // prettier-ignore
                    switch (k) {
                        case 'search':
                            options.push({
                                id: v,
                                text: `${v}`,
                                key: k,
                                label: '房间编号'
                            })
                            break
                        case 'contractStatus':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.contractStatus.val(p),
                                key: k,
                                label: '租约状态'
                            }))
                            break
                        case 'rentLength':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.enums.RENT_LENGTH.getName(p),
                                key: k,
                                label: '租赁期限'
                            }))
                            break
                        case 'rentPayMethod':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.enums.RENT_PAY_METHOD.getName(p),
                                key: k,
                                label: '交费方式'
                            }))
                            break
                        case 'cusType':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.cusType.val(p),
                                key: k,
                                label: '客户类型'
                            }))
                            break
                        case 'createUser':
                            v.forEach(p => {
                                var user = this.createUserList.find(s => s.id === p)

                                if(user){
                                    options.push({
                                        id: p,
                                        text: user.nickname,
                                        key: k,
                                        label: '签约人'
                                    })
                                }
                            })
                            break
                    }
                }
            })

            return options
        },
    },
}
</script>

<style lang="less" scoped>
.adv {
    &-form {
        padding: 0 10px;
    }
    &-text {
        margin-right: 10px;
    }
    &-icon {
        vertical-align: -1px;
    }
    &-check-tag {
        padding: 2px 12px;
        height: auto;
    }
}
</style>
